import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'src/app/shared/shared.module';
import { UnauthorizedComponent } from './unauthorized.component';
import { UnauthorizedRoutingModule } from './unauthorized-routing.module';
import { HeaderModule } from './header/header.module';
import { FooterModule } from './footer/footer.module';
@NgModule({
  declarations: [
    UnauthorizedComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    UnauthorizedRoutingModule,
    HeaderModule,
    FooterModule
  ]
})
export class UnauthorizedModule {
}

